import { select } from "d3";
import { replaceCharacters } from "../../_helpers/_helpers";
export class Text {
  constructor(svg, svgAux = null, _this = null) {
    this.svg = svg;
    this.svgAux = svgAux ? svgAux : svg;
    this.context = _this;
  }

  textsZoom(_this, allData) {
    const context = this;

    allData.forEach((obj) => {
      obj.yFields.forEach((field, i) => {
        const name = replaceCharacters(obj.customNameTexts[i]);
        const yOffset = obj.yOffsets ? obj.yOffsets[i] || 0 : 0;
        const yFieldsIncludes = obj.yFieldsIncludes || null;
        const positionText = obj.positionText || "";
        const index = i;
        const yField = obj.yField[i];
        const textField = obj.textField[i];
        const formatText = obj.formatText;
        const maxHeight = obj.maxHeight;

        this.svg[name]
          .attr("transform", (d) => {
            let accumulated = 0;

            if (yFieldsIncludes && positionText !== "bottom") {
              let positiveAccum = 0;
              let negativeAccum = 0;

              yFieldsIncludes
                .slice(0, index + 1)
                .filter((fieldName) => !Number.isNaN(d[fieldName]))
                .forEach((fieldName) => {
                  if (!fieldName) return;
                  const value = +d[fieldName];

                  if (value >= 0) {
                    if (index === yFieldsIncludes.indexOf(fieldName)) {
                      accumulated =
                        this.svg.y(positiveAccum) - (value < 8 ? 0 : 5);
                    }
                    positiveAccum += value;
                  } else {
                    if (index === yFieldsIncludes.indexOf(fieldName)) {
                      accumulated =
                        this.svg.y(negativeAccum + value) +
                        (value > -8 ? 0 : -5);
                    }
                    negativeAccum += value;
                  }
                });
            } else if (positionText === "bottom") {
              accumulated = this.svg.y(d["zeroFld"]) + yOffset;
            } else {
              accumulated = this.svg.y(d[field]) + yOffset;
            }

            return `translate(${this.svg.x(d[obj.xField]) +
              Number(obj.xOffsets[i])}, ${accumulated})`;
          })
          .text(function(d) {
            let text;
            if (yFieldsIncludes) {
              const heightCurrentBar = context.getHeightCurrentBar(
                d,
                yFieldsIncludes,
                index,
              );
              if (Array.isArray(yField)) {
                let customText = 0;
                for (let yF of yField) {
                  customText += d[yF];
                }
                text = formatText ? formatText(customText) : customText;
              } else if (d[textField] < 0.01 && d[textField] > -0.01) {
                text = "";
              } else if (heightCurrentBar && heightCurrentBar < maxHeight) {
                this.classList.add("fa");
                text = "\uf141";
              } else {
                this.classList.remove("fa");
                text = formatText ? formatText(d[textField]) : d[textField];
              }
            } else {
              this.classList.remove("fa");
              text = formatText ? formatText(d[textField]) : d[textField];
            }

            return text;
          });
      });
    });
  }

  getHeightCurrentBar(d, yFields, index) {
    let heightCurrentBarHeight;

    if (yFields) {
      const name = replaceCharacters(yFields[index]);
      const joinYField = name
        .split(" ")
        .join("")
        .replace("Perc", "");
      const currentBar = select(`.stackedBar${joinYField}${+d["date"]}`);
      const heightCurrentBar = currentBar.node();
      if (heightCurrentBar) {
        heightCurrentBarHeight = heightCurrentBar.getBoundingClientRect()
          .height;
      }
    }
    return heightCurrentBarHeight || 14;
  }
}
